import "./LessonPlansPage.css";
import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { CircularProgress } from "@material-ui/core";

import DownloadTable from "./LessonPlanTable/DownloadTable/DownloadTable";
import TableEditor from "./LessonPlanTable/EditTable/TableEditor";

import useGroupPlan from "./hooks/useGroupPlan";

function GroupLessonPLanPage() {
  const history = useHistory();
  const location = useLocation();
  const [view, setView] = useState("landscape");
  const [action, setAction] = useState("edit");

  const {
    planIds,
    columns,
    lessonPlans,
    info,
    fetchLessonPlan,
    setColumns,
    syncCell,
    syncColumn,
    syncRemovedColumn,
    loading,
  } = useGroupPlan();

  const getQuery = () => {
    const queryParam = new URLSearchParams(location.search);
    return {
      teacherId: queryParam.get("teacherId"),
      startDate: queryParam.get("startDate"),
      action: queryParam.get("action"),
      view: queryParam.get("view"),
    };
  };

  function changeView() {
    const newView = !view ? "landscape" : "";
    updateQuery({ view: newView });
  }

  function updateQuery(newQuery) {
    const query = getQuery();
    const params = new URLSearchParams({
      ...query,
      ...newQuery,
    });
    history.replace({ pathname: location.pathname, search: params.toString() });
  }

  useEffect(() => {
    const query = getQuery();
    setAction(query.action || "edit");
    setView(query.view || "");
  }, [location]);

  async function refresh() {
    const query = getQuery();
    fetchLessonPlan({ teacherId: query.teacherId, startDate: query.startDate });
  }

  useEffect(() => {
    refresh();
  }, []);

  return (
    <div className={`${action === "download" ? "" : "lp-container mt-5 "}`}>
      {loading ? (
        <div style={{ width: "fit-content", margin: "50px auto" }}>
          <CircularProgress />
        </div>
      ) : (
        <>
          {action === "edit" && (
            <TableEditor
              view={view}
              info={info}
              columns={columns}
              changeView={changeView}
              updateQuery={updateQuery}
              setColumns={setColumns}
              syncCell={syncCell}
              syncColumn={syncColumn}
              syncRemovedColumn={syncRemovedColumn}
              refresh={refresh}
              planIds={planIds}
            />
          )}
          {action === "download" && lessonPlans[0] && (
            <DownloadTable
              view={view}
              info={info}
              columns={columns}
              updateQuery={updateQuery}
              changeView={changeView}
            />
          )}
        </>
      )}
    </div>
  );
}

export default GroupLessonPLanPage;
